import React from 'react';
import styled, { css } from 'styled-components';
import Popover from './Popover';
export var PopupDirections;
(function (PopupDirections) {
    PopupDirections["TOP"] = "TOP";
    PopupDirections["RIGHT"] = "RIGHT";
    PopupDirections["RIGHT_TOP"] = "RIGHT_TOP";
    PopupDirections["BOTTOM"] = "BOTTOM";
    PopupDirections["BOTTOM_LEFT"] = "BOTTOM_LEFT";
    PopupDirections["LEFT"] = "LEFT";
    PopupDirections["LEFT_TOP"] = "LEFT_TOP";
})(PopupDirections || (PopupDirections = {}));
const Tooltip = (props) => {
    const { children, preserveWhitespace = false, HeaderIcon, IconWrapper, className, popupDirection = PopupDirections.TOP, TooltipContainer = DefaultTooltipContainer, OverlayContainer = DefaultTooltipOverlayContainer, } = props;
    const TooltipLabelContainerWithDirection = (props) => (React.createElement(OverlayContainer, { popupDirection: popupDirection, ...props }));
    // const StyledTooltipContainer = ( props ) => (
    { /*<TooltipContainer className={className} {...props}/> );*/
    }
    return React.createElement(Popover, { PopoverWrapper: TooltipContainer, HeaderWrapper: IconWrapper, HeaderComponent: HeaderIcon, ChildrenWrapper: TooltipLabelContainerWithDirection, ChildrenComponent: React.createElement(TooltipText, { preserveWhitespace: preserveWhitespace }, children), className: className });
};
const DefaultTooltipContainer = styled.div `
    position: relative;
    height: 14px;
    width: 14px;

    cursor: pointer;
`;
export const DefaultTooltipOverlayContainer = styled("div") `
    position: absolute;

    display: none;
    display: ${props => props.isOpen && 'block'};
    outline: none;

    width: max-content;
    max-width: 300px;
    white-space: normal;

    padding: 10px;
    background-color: ${props => props.theme.colors.tooltipBackground};
    border-radius: 2px;

    box-shadow: ${props => props.shadowCss || props.theme.boxShadows.soft};

    z-index: 901;

    &:after {

        position: absolute;

        height: 0;
        width: 0;
        
        pointer-events: none;
        border: solid transparent;
        border-color: rgba(255,255,255,0);
        border-width: 6px;
        
        content: ' ';
    }
    
    ${props => props.popupDirection === PopupDirections.TOP && TopTooltipLabelContainerStyling}    
    ${props => props.popupDirection === PopupDirections.RIGHT && RightTooltipLabelContainerStyling}
    ${props => props.popupDirection === PopupDirections.BOTTOM && BottomTooltipLabelContainerStyling}
    ${props => props.popupDirection === PopupDirections.BOTTOM_LEFT && BottomLeftTooltipLabelContainerStyling}
    ${props => props.popupDirection === PopupDirections.LEFT && LeftTooltipLabelContainerStyling}
    ${props => props.popupDirection === PopupDirections.RIGHT_TOP && RightTopTooltipLabelContainerStyling}    
    ${props => props.popupDirection === PopupDirections.LEFT_TOP && LeftTopTooltipLabelContainerStyling}    
`;
const TopTooltipLabelContainerStyling = css `
    left: 50%;
    bottom: 30px;
    transform: translateX(-50%);
    
    &:after {

        left: 50%;
        top: 100%;
        transform: translateX(-50%);
        
        border-top-color: ${props => props.theme.colors.tooltipBackground};
    }
`;
const RightTooltipLabelContainerStyling = css `
    top: 50%;
    left: 100%;
    transform: translateY(-50%) translateX(10px);
    
    &:after {

        top: 50%;
        right: 100%;
        transform: translateY(-50%);
        
        border-right-color: ${props => props.theme.colors.tooltipBackground};
    }
`;
const RightTopTooltipLabelContainerStyling = css `
    top: 200%;
    left: 30px;
    transform: translateY(-50%);
    
    &:after {

        top: 25%;
        right: 100%;
        transform: translateY(-50%);
        
        border-right-color: ${props => props.theme.colors.tooltipBackground};
    }
`;
const BottomTooltipLabelContainerStyling = css `
    left: 50%;
    top: 30px;
    transform: translateX(-50%);
    
    &:after {

        left: 50%;
        bottom: 100%;
        transform: translateX(-50%);
        
        border-bottom-color: ${props => props.theme.colors.tooltipBackground};
    }
`;
const BottomLeftTooltipLabelContainerStyling = css `
    right: 50%;
    top: 100%;
    transform: translateX(20px);
    
    margin-top: 10px;
    
    &:after {

        right: 15px;
        bottom: 100%;
        
        border-bottom-color: ${props => props.theme.colors.tooltipBackground};
    }
`;
const LeftTooltipLabelContainerStyling = css `
    top: 50%;
    right: 30px;
    transform: translateY(-50%);
    
    &:after {

        top: 50%;
        left: 100%;
        transform: translateY(-50%);
        
        border-left-color: ${props => props.theme.colors.tooltipBackground};
    }
`;
const LeftTopTooltipLabelContainerStyling = css `
    top: 200%;
    right: 30px;
    transform: translateY(-50%);
    
    &:after {

        top: 25%;
        left: 100%;
        transform: translateY(-50%);
        
        border-left-color: ${props => props.theme.colors.tooltipBackground};
    }
`;
const TooltipText = styled('span') `
    opacity: .9;
    font-family: ${props => props.theme.fonts.regular};
    font-size: 12px;
    line-height: 16px;
    user-select: none;
    color: ${props => props.theme.colors.white};
    white-space: ${props => props.preserveWhitespace && 'pre-wrap'};
`;
export default Tooltip;
//# sourceMappingURL=Tooltip.js.map